"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrongAnswerInFormBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var WrongAnswerInFormBanner = /** @class */ (function (_super) {
    __extends(WrongAnswerInFormBanner, _super);
    function WrongAnswerInFormBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.setState({
            isAnswerValid: true
        });
        _this.errorMessage = _this.getSetting("errorMessage");
        _this.questionId = _this.getSetting("questionId");
        return _this;
    }
    WrongAnswerInFormBanner.prototype.render = function () {
        var _this = this;
        var handleJumpToInput = function () {
            var inputElement = document.getElementById(_this.questionId);
            if (inputElement) {
                inputElement.focus();
            }
        };
        return ((0, jsx_runtime_1.jsxs)("div", { className: "page-validation journey-validation-summary validation-error-top", role: "alert", children: [(0, jsx_runtime_1.jsx)("div", { className: "page-validation-alert", children: (0, jsx_runtime_1.jsx)("img", { className: "page-validation-alert-icon", alt: "Alert icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-red.svg") }) }), (0, jsx_runtime_1.jsxs)("div", { className: "page-validation-message", children: [(0, jsx_runtime_1.jsx)("p", { className: "page-validation-message-top", children: this.errorMessage }), (0, jsx_runtime_1.jsx)("div", { className: "link-container", children: (0, jsx_runtime_1.jsx)("a", { className: "btn btn-text", onClick: handleJumpToInput, children: (0, jsx_runtime_1.jsx)("strong", { children: "Go to question" }) }) })] })] }));
    };
    return WrongAnswerInFormBanner;
}(plugin_journey_1.WidgetBase));
exports.WrongAnswerInFormBanner = WrongAnswerInFormBanner;
//# sourceMappingURL=WrongAnswerInFormBanner.js.map